module.exports = __webpack_public_path__ + "img/carbon-menu-carbon.95f10bf0.svg";